/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Case } from '../../models/case';

export interface GetCases$Plain$Params {

/**
 * string containing the search parameter
 */
  searchString?: string;
}

export function getCases$Plain(http: HttpClient, rootUrl: string, params?: GetCases$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Case>>> {
  const rb = new RequestBuilder(rootUrl, getCases$Plain.PATH, 'get');
  if (params) {
    rb.query('searchString', params.searchString, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Case>>;
    })
  );
}

getCases$Plain.PATH = '/api/Case';
